import { render, staticRenderFns } from "./WebsitesTable.vue?vue&type=template&id=4c0caa56"
import script from "./WebsitesTable.vue?vue&type=script&lang=js"
export * from "./WebsitesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports